import { GridSortDirection } from '@mui/x-data-grid';
import { SortModel, FilterModel } from './FilterSortModel';

//Helperfunctions for serialization and deserialization
export function serializeSortModel(model: SortModel): string | undefined {
    if (!model || model.length === 0) {
        return undefined;
    }

    return `${model[0].field}:${model[0].sort}`;
}
export function deserializeSortModel(modelString: string): SortModel {
    const [field, sort] = modelString.split(':');
    return [
        {
            field: field,
            sort: sort as GridSortDirection
        }
    ];
}
export function serializeFilterModel(model: FilterModel): string | undefined {
    if (!model || model.items.length === 0) {
        return undefined;
    }

    const item = model.items[0];
    return `${item.field}:${item.operator}:${item.value}`;
}
export function deserializeFilterModel(modelString: string): FilterModel {
    const [field, operator, value] = modelString.split(':');
    return {
        items: [{ field, operator, value }]
    };
}
